<template>
  <div class="mirco-app-report preview">
    <micro-app
      :name="microName"
      :url="getUrl"
      iframe
      router-mode="native"
      :baseroute="`/${microName}`"
      :data="storeInfo"
    ></micro-app>
  </div>
</template>
<script lang="ts">
import microApp from '@micro-zoe/micro-app';
import configEnv from '@/config/user.env';
import { useStore } from 'vuex';
import { computed, defineComponent, onMounted, reactive, ref, toRefs } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { lotsUIEventInstance } from '@annto/ui';

export default defineComponent({
  setup() {
    const storeInfo = ref({});
    // 路由替换跳转方法
    const routerReplaceMethod = (to: any,) => {
      // 用于首次打开页面还未加载到子系统的路由信息时，将子系统的路由meta信息下发通信给基座，需要根据子系统路由meta信息进行权限卡控
      if (to && to.meta){
        let system = to.meta.system;
        if (!system) {
          return;
        }
        system = system.charAt(0).toUpperCase() + system.slice(1);
        const nRoutePath = route.path.replace('/microOtp', `/micro${system}`);
        router.replace({
          path: nRoutePath,
          query: {
            ...route.query,
            // ...to.meta,  // 将 meta 展开到 query 中
            ...(to.meta?.authority ? { toMetaAuthority: to.meta.authority } : {}),
          },
        });
      }
    };
    const state = reactive({
      router: {},
      user: null,
      authority: null,
      currentTenant: null,
      appId: null,
      appList: null,
      btnPermissions: null,
      path: '',
      query: {},
      applicationCode: '',
      currentRoleDic: {}, //当前角色信息下发给子系统
      roleList: [], // 角色列表
    });
    const store = useStore();

    const route = useRoute();
    const router = useRouter();
    const microName = 'microOtp';

    microApp.getData(microName);

    const getUrl = computed(() => {
      return configEnv.microOmsUrl;
    });

    const initPage = () => {
      state.router = router; // 假设 router 是从 useRouter 获取的
      state.user = store.getters.user; // 从 Vuex 获取用户信息
      state.authority = store.getters.authority;
      state.currentTenant = store.getters.currentTenant;
      state.appId = store.getters.appId;
      state.appList = store.getters.appList;
      state.btnPermissions = store.getters.btnPermissions;
      state.applicationCode = store.state.applicationCode;
      state.path = route.path;
      state.query = route.query;
      // 获取当前角色配置信息
      const roleItem = store.state.roleList.find((item: { roleCode: any }) => item.roleCode === store.state.curRole);
      // 提取当前角色信息的code和name
      const roleDataDic = {
        code: store?.state?.curRole ?? '',
        name: roleItem?.roleName ?? '',
      };
      // 下发给子系统的当前角色配置信息的code和name
      state.currentRoleDic = roleDataDic;
      // 角色列表
      state.roleList = store.state.roleList;

      const {
        user,
        authority,
        currentTenant,
        appId,
        appList,
        btnPermissions,
        path,
        query,
        applicationCode,
        currentRoleDic,
        roleList,
      } = toRefs(state);
      // 这里的一些参数除了重点说明的两个一般物流的项目都会有;
      storeInfo.value = {
        system: 'EL', // 下发基座系统名称
        type: 'updateData',
        router,
        user,
        authority,
        currentTenant,
        appId,
        appList,
        btnPermissions,
        path,
        query,
        applicationCode,
        lotsUIEventInstance,
        currentRoleDic,
        roleList,
        routerReplaceMethod: routerReplaceMethod, // 路由替换跳转方法
      };
    };

    onMounted(() => {
      // microApp.setData(microName, { path: route.path, query: route.query || {} });
      initPage();
    });

    return {
      microName,
      storeInfo,
      getUrl,
    };
  },
});
</script>
<style lang="less">
.mirco-app-report {
  height: 100%;

  micro-app[name='microOtp'] {
    width: 100%;
    height: 100%;

    .change-version-btn {
      padding: 1px 6px;
      top: 33px;
      z-index: 10;
    }

    .tms-performance-dialog .form-container .md-col-8 .md-form-item__content {
      .show-tip {
        text-align: left;
        width: 100%;
      }
      button {
        text-align: left;
        width: 100%;
        border: none;
        span {
          text-align: left;
          width: 100%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          display: block;
        }
      }
    }
    .tms-performance-dialog .form-container div:nth-child(2) .table-btn {
      width: 100%;
    }

    .root-panel {
      height: 100%;
    }
    .layout-content {
      margin-top: 0;
    }
    .vxe-table--render-default .vxe-table--fixed-right-wrapper.scrolling--middle {
      box-shadow: -8px 0px 10px -5px rgba(0, 0, 0, 0.12);
    }
    .otp-app {
      .md-range-editor--small.md-input__inner {
        height: 24px;
      }
    }
  }
}
</style>